import React, { useEffect, useState } from "react";
import "admin-lte/dist/css/adminlte.min.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar2 from "./Sidebar2";
import { useTheme } from "../../../context/ThemeContext";
import api from "../../../utils/api";
import SportsSidebar from "./SportsSidebar";

const base_url = process.env.REACT_APP_API_URL;

const AdminHeader = ({ toggleSidebar, isSidebarOpen, isMobile }) => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [isSidebar2Open, setIsSidebar2Open] = useState(false);
  const { theme, handleThemeChange } = useTheme();
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeRightMenu, setActiveRightMenu] = useState(false);
  const [sportsOpen, setSportsOpen] = useState(false);

  const auth = localStorage.getItem("admin");

  const handleLogout = () => {
    navigate("/admin/login");
    localStorage.removeItem("admin");
  };

  const fetchBalance = async () => {
    try {
      const response = await api.post(
        "/api/webapi/admin/listMember",
        {
          typeid: "1",
          pageno: 1,
          limit: 10,
          search: "",
          language: "vi",
        },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        },
      );

      // console.log('rpee head',response);
      if (response?.status) {
        const bal = response?.data.datas;
        // console.log('ball',bal);
        bal?.map((ball) => {
          if (ball?.token === auth) {
            setData(ball?.money);
          }
        });
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
    }
  };

  function updateRightMenu() {
    setActiveRightMenu((prev) => !prev);
  }

  function sportsOpenCloseFun() {
    setSportsOpen((prev) => !prev);
  }

  useEffect(() => {
    fetchBalance();
  }, []);

  return (
    <>
      <style>
        {`.custom-header {
  height: 52px;
  background: #0088cc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  color: white;
  font-family: Arial, sans-serif;
}

.custom-header .left-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.custom-header .menu-btn {
  background: none;
  border: none;
  font-size: 22px;
  color: white;
  cursor: pointer;
}

.custom-header .logo img {
  max-width: 100%;
  max-height: 40px;
  height: auto;
  width: auto;
}

.custom-header .menu {
  display: flex;
  list-style: none;
  gap: 2px;
  margin: 0;
  padding: 0;
}

.custom-header .menu li {
  cursor: pointer;
  font-size: 13px;
  transition: 0.3s;
  font-weight: bold;
  padding: 7px 10px;
}

.custom-header .menu li a {
  color: #fff !important;
}

.custom-header .menu li:hover {
  background-color: #2c3e50;
  color: #fff;
}

.custom-header .right-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

.custom-header .balance-display {
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;
  position: relative;
}

.custom-header .search-box {
  position: relative;
}

.custom-header .search-box input {
  height: 40px;
  border-radius: 3px;
  border: none;
  padding: 0 25px 0 10px;
  color: #495057 !important;
  font-weight: 500;
}

.custom-header .search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: black;
  font-size: 24px;
}

.custom-header .menu-item {
  position: relative;
}

.custom-header .menu-item.active {
  background: #2c3e50 !important;
}

.custom-header .live-dropdown {
  position: absolute;
  top: 35px;
  left: 0;
  width: 240px;
  background: #0088cc;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  color: white;
  z-index: 999;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.custom-header .live-dropdown a {
  color: #fff !important;
}

.custom-header .live-dropdown div {
  padding: 7px 10px;
  cursor: pointer;
  font-size: 13px;
}

.custom-header .live-dropdown div:hover {
  background-color: #2c3e50;
}

@media (max-width: 768px) {
  .custom-header .search-icon {
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      color: black;
      font-size: 10px;
  }

    .custom-header .search-box input {
        height: 20px;
        border-radius: 3px;
        border: none;
        padding: 0 0px 0 5px;
        color: #495057 !important;
        font-weight: 500;
        width: 75px;
    }
    .custom-header .balance-display {
        font-weight: 600;
        cursor: pointer;
        font-size: 0.4rem;
        position: relative;
    }

    .custom-header .right-section {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .custom-header .menu {
        display: flex;
        list-style: none;
        gap: 0px;
        margin: 0;
        padding: 0;
        flex-wrap: wrap;
    }
    .custom-header .menu li {
        cursor: pointer;
        font-size: 5px;
        transition: 0.3s;
        font-weight: bold;
        padding: 0px 5px;
    }

  .custom-header .menu-btn {
      background: none;
      border: none;
      font-size: 10px;
      color: white;
      cursor: pointer;
  }

  .custom-header .logo img {
    max-width: 30px;
  }

  .custom-header .left-section {
      display: flex;
      align-items: center;
      gap: 0px;
  }

  .custom-header {
      height: 40px;
      background: #0088cc;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      color: white;
      font-family: Arial, sans-serif;
  }
    .custom-header .live-dropdown {
      top: 10px;
  }
}
`}
      </style>

      <div className="wrapper">
        {/* Navbar */}
        <>
          <nav className="custom-header">
            {/* LEFT SECTION */}
            <div className="left-section">
              <div className="logo">
                <img src="/assets/all_images/header/alllogo.png" />
              </div>

              <button className="menu-btn" onClick={sportsOpenCloseFun}>
                ☰
              </button>

              <ul className="menu">
                <li onClick={()=>navigate("/admin/user2")}>List of Clients</li>
                <li className="menu-item" onClick={() => navigate("/admin/MarketOverview")}>Market Analysis</li>
                <li
                  className={`menu-item ${activeMenu === "live" ? "active" : ""}`}
                  onMouseEnter={() => setActiveMenu("live")}
                  onMouseLeave={() => setActiveMenu(null)}
                >
                  <a href="#">Live Market ▾</a>

                  {activeMenu === "live" && (
                    <div
                      className="live-dropdown"
                      onMouseEnter={() => setActiveMenu("live")}
                      onMouseLeave={() => setActiveMenu(null)}
                    >
                      <div>
                        <a href="#">Premium Casino</a>
                      </div>
                      <div>
                        <a href="#">Tembo Casino</a>
                      </div>
                      <div>
                        <a href="#">Vip Casino</a>
                      </div>
                      <div>
                        <a href="#">Lucky 6</a>
                      </div>
                      <div>
                        <a href="#">Mogambo</a>
                      </div>
                      <div>
                        <a href="#">Unique Teenpatti</a>
                      </div>
                      <div>
                        <a href="#">Roulette</a>
                      </div>
                      <div>
                        <a href="#">Super Over2</a>
                      </div>
                      <div>
                        <a href="#">Lucky15</a>
                      </div>
                      <div>
                        <a href="#">Goal</a>
                      </div>
                      <div>
                        <a href="#">Binary</a>
                      </div>
                      <div>
                        <a href="#">Race 20-20</a>
                      </div>
                      <div>
                        <a href="#">Queen</a>
                      </div>
                      <div>
                        <a href="#">Baccarat</a>
                      </div>
                      <div>
                        <a href="#">Sport Casino</a>
                      </div>
                      <div>
                        <a href="#">Casino War</a>
                      </div>
                      <div>
                        <a href="#">Worli</a>
                      </div>
                      <div>
                        <a href="#">3 Card Judgement</a>
                      </div>
                      <div>
                        <a href="#">32 Card Casino</a>
                      </div>
                      <div>
                        <a href="#">Live Teenpatti</a>
                      </div>
                      <div>
                        <a href="#">Teenpatti 2.0</a>
                      </div>
                      <div>
                        <a href="#">Live Poker</a>
                      </div>
                      <div>
                        <a href="#">Andar Bahar</a>
                      </div>
                      <div>
                        <a href="#">Lucky 7</a>
                      </div>
                      <div>
                        <a href="#">Dragon Tiger</a>
                      </div>
                      <div>
                        <a href="#">Others</a>
                      </div>
                    </div>
                  )}
                </li>

                <li
                  className={`menu-item ${activeMenu === "live-virtual" ? "active" : ""}`}
                  onMouseEnter={() => setActiveMenu("live-virtual")}
                  onMouseLeave={() => setActiveMenu(null)}
                >
                  <a href="#">Live Virtual Market ▾</a>

                  {activeMenu === "live-virtual" && (
                    <div
                      className="live-dropdown"
                      onMouseEnter={() => setActiveMenu("live-virtual")}
                      onMouseLeave={() => setActiveMenu(null)}
                    >
                      <div>
                        <a href="#">20-20 DTL</a>
                      </div>
                      <div>
                        <a href="#">Amar Akbar Anthony</a>
                      </div>
                      <div>
                        <a href="#">Muflis Teenpatti</a>
                      </div>
                      <div>
                        <a href="#">1 Day Teenpatti</a>
                      </div>
                      <div>
                        <a href="#">1 Day Dragon Tiger</a>
                      </div>
                      <div>
                        <a href="#">Lucky 7</a>
                      </div>
                      <div>
                        <a href="#">Bollywood Casino</a>
                      </div>
                      <div>
                        <a href="#">20-20 Teenpatti</a>
                      </div>
                      <div>
                        <a href="#">Trio</a>
                      </div>
                    </div>
                  )}
                </li>

                <li
                  className={`menu-item ${activeMenu === "reports" ? "active" : ""}`}
                  onMouseEnter={() => setActiveMenu("reports")}
                  onMouseLeave={() => setActiveMenu(null)}
                >
                  <a href="#">Reports ▾</a>

                  {activeMenu === "reports" && (
                    <div
                      className="live-dropdown"
                      onMouseEnter={() => setActiveMenu("reports")}
                      onMouseLeave={() => setActiveMenu(null)}
                    >
                      <div>
                        <a href="#">Account Statement</a>
                      </div>
                      <div>
                        <a href="#">Current Bets</a>
                      </div>
                      <div>
                        <a href="#">General Report</a>
                      </div>
                      <div>
                        <a href="#">Game Report</a>
                      </div>
                      <div>
                        <a href="#">Casino Report</a>
                      </div>
                      <div>
                        <a href="#">Profit And Loss</a>
                      </div>
                      <div>
                        <a href="#">Casino Result Report</a>
                      </div>
                      <div>
                        <a href="#">General Lock</a>
                      </div>
                      <div>
                        <a href="#">User Register Detail</a>
                      </div>
                      <div>
                        <a href="#">Total Profit Loss</a>
                      </div>
                    </div>
                  )}
                </li>

                <li>Multi Login</li>
              </ul>
            </div>

            {/* RIGHT SECTION */}
            <div className="right-section">
              <div
                className="balance-display"
                onClick={() => updateRightMenu()}
              >
                <span>{data || 0}khb ▾</span>
                {activeRightMenu === true && (
                  <div className="live-dropdown">
                    <div>
                      <a href="#">Secure Auth Verification</a>
                    </div>
                    <div>
                      <a href="#">Change Password</a>
                    </div>
                    <div>
                      <a href="#" onClick={handleLogout}>Logout</a>
                    </div>
                  </div>
                )}
              </div>

              <div className="search-box">
                <input type="text" placeholder="All Client" />
                <i className="fa-solid fa-magnifying-glass-plus search-icon"></i>
              </div>
            </div>
          </nav>
        </>

        <SportsSidebar
          isOpen={sportsOpen}
          onClose={() => setSportsOpen(false)}
        />

        {/* Sidebar2 */}
        <Sidebar2
          isOpen={isSidebar2Open}
          toggleSidebar={() => setIsSidebar2Open(!isSidebar2Open)}
        />
      </div>
    </>
  );
};

export default AdminHeader;
